import React from 'react';

const FONT = "'SamsungOne', 'Samsung Sharp Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export const RemoveAdsModal = ({ visible, onClose, price, purchasing, restoring, error, onPurchase, onRestore, theme }) => {
  if (!visible) return null;

  const isDark  = theme === 'dark';
  const bg      = isDark ? '#1C1C1E' : '#FFFFFF';
  const overlay = 'rgba(0,0,0,0.6)';
  const text    = isDark ? '#FFFFFF' : '#1C1C1E';
  const sub     = isDark ? '#9E9E9E' : '#8A8A8E';
  const border  = isDark ? '#2A2A2A' : '#D8D8D8';
  const btnBg   = '#4A5240';

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: overlay,
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: bg, width: '100%', maxWidth: '480px',
          borderRadius: '24px 24px 0 0',
          padding: '28px 24px 40px',
          fontFamily: FONT,
        }}
      >
        {/* Handle bar */}
        <div style={{ width: 36, height: 4, background: border, borderRadius: 2, margin: '0 auto 24px' }}/>

        {/* Icon */}
        <div style={{ fontSize: 48, textAlign: 'center', marginBottom: 12 }}>🚫</div>

        {/* Title */}
        <div style={{ fontSize: '1.3rem', fontWeight: 700, color: text, textAlign: 'center', marginBottom: 8 }}>
          Remove Ads
        </div>

        {/* Subtitle */}
        <div style={{ fontSize: '0.9rem', color: sub, textAlign: 'center', marginBottom: 28, lineHeight: 1.5 }}>
          Enjoy Calc 360 without interruptions.<br/>One-time payment, no subscription.
        </div>

        {/* Features */}
        {[
          'No banner ads ever again',
          'No interstitial ads',
          'Support independent development',
        ].map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <div style={{ width: 20, height: 20, borderRadius: '50%', background: btnBg,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 11, color: '#fff', flexShrink: 0 }}>✓</div>
            <span style={{ fontSize: '0.9rem', color: text }}>{f}</span>
          </div>
        ))}

        {/* Error */}
        {error && (
          <div style={{ marginTop: 12, padding: '10px 14px', borderRadius: 10,
            background: 'rgba(255,59,48,0.1)', color: '#FF3B30',
            fontSize: '0.85rem', textAlign: 'center' }}>
            {error}
          </div>
        )}

        {/* Buy button */}
        <button
          onClick={onPurchase}
          disabled={purchasing || restoring}
          style={{
            width: '100%', marginTop: 24, padding: '16px',
            borderRadius: 50, border: 'none', cursor: purchasing ? 'default' : 'pointer',
            background: btnBg, color: '#FFFFFF',
            fontSize: '1rem', fontWeight: 700, fontFamily: FONT,
            opacity: purchasing ? 0.7 : 1,
          }}
        >
          {purchasing ? 'Processing…' : `Buy for ${price}`}
        </button>

        {/* Restore */}
        <button
          onClick={onRestore}
          disabled={purchasing || restoring}
          style={{
            width: '100%', marginTop: 12, padding: '12px',
            borderRadius: 50, border: `1px solid ${border}`,
            background: 'transparent', cursor: restoring ? 'default' : 'pointer',
            color: sub, fontSize: '0.9rem', fontFamily: FONT,
            opacity: restoring ? 0.7 : 1,
          }}
        >
          {restoring ? 'Restoring…' : 'Restore previous purchase'}
        </button>
      </div>
    </div>
  );
};
